import { Link } from 'react-router-dom';
import { animeArticles } from '@/mocks/anime';

const latestAnime = animeArticles.filter((a) => a.isNew).slice(0, 6);
const recentUpdates = [...animeArticles].sort(
  (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
).slice(0, 6);

export default function LatestUpdates() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {/* New Arrivals */}
          <div>
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                最新上架
              </h2>
              <Link
                to="/category/qihuan"
                className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 cursor-pointer whitespace-nowrap"
              >
                查看更多
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </Link>
            </div>
            <div className="space-y-3">
              {latestAnime.map((anime) => (
                <Link
                  key={anime.id}
                  to={`/article/${anime.id}`}
                  className="flex items-center gap-4 p-3 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
                >
                  <div className="w-16 h-20 flex-shrink-0 rounded-md overflow-hidden">
                    <img
                      src={anime.coverImage}
                      alt={anime.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1">
                      {anime.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-1 line-clamp-2">
                      {anime.description}
                    </p>
                    <div className="flex items-center gap-2 mt-2">
                      <span className="text-xs px-1.5 py-0.5 bg-accent-100 text-accent-700 rounded font-medium whitespace-nowrap">
                        {anime.categoryName}
                      </span>
                      <span className="text-xs text-foreground-400">{anime.episodes}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* Recent Updates */}
          <div>
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                最近更新
              </h2>
              <Link
                to="/category/rexue"
                className="text-sm text-primary-500 hover:text-primary-600 flex items-center gap-1 cursor-pointer whitespace-nowrap"
              >
                查看更多
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </Link>
            </div>
            <div className="space-y-3">
              {recentUpdates.map((anime) => (
                <Link
                  key={anime.id}
                  to={`/article/${anime.id}`}
                  className="flex items-center gap-4 p-3 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
                >
                  <div className="w-16 h-20 flex-shrink-0 rounded-md overflow-hidden">
                    <img
                      src={anime.coverImage}
                      alt={anime.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1">
                      {anime.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-1 line-clamp-2">
                      {anime.description}
                    </p>
                    <div className="flex items-center gap-2 mt-2">
                      <span className="text-xs px-1.5 py-0.5 bg-primary-100 text-primary-700 rounded font-medium whitespace-nowrap">
                        {anime.categoryName}
                      </span>
                      <span className="text-xs text-foreground-400">更新于 {anime.updateDate}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}